<template>
  <div class="step2 section is-mobile-wider">
    <div class="container has-text-centered">
      <div class="coloumn column is-8 is-offset-2">
        <h3 class="subtitle is-4 is-size-5-mobile">
          Ist deine Rechnungsadresse mit deiner Lieferadresse identisch?
        </h3>
        <ValidationObserver ref="observer" v-slot="{ passes }">
          <div class="field">
            <b-radio
              v-model="giftquestion"
              size="is-large"
              type="is-info"
              native-value="selbst"
              >Ja, identisch</b-radio
            >
            <b-radio
              v-model="giftquestion"
              size="is-large"
              type="is-info"
              native-value="verschenken"
              >Nein, abweichend</b-radio
            >
          </div>

          <div class="container kontaktdaten has-text-left">
            <h4
              class="subtitle is-5 spacetop has-text-weight-bold"
              v-if="giftquestion == 'selbst'"
            >
              Deine Rechnungs- und Lieferadresse
            </h4>
            <h4
              class="subtitle is-5 spacetop has-text-weight-bold"
              v-if="giftquestion !== 'selbst'"
            >
              Deine Rechnungsadresse
            </h4>
            <div class="columns is-multiline">
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="buyerfirst"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Vorname"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="buyerfirst"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="buyerlast"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Nachname"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="buyerlast"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|min:4"
                  name="StreetNumber"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Straße und  Nr."
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="StreetNumber"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <b-field label="weitere Adressangaben">
                  <b-input
                    custom-class="is-large"
                    v-model="adressline2"
                  ></b-input>
                </b-field>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|digits:5"
                  name="zip"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Postleitzahl"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input custom-class="is-large" v-model="zip"></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|min:2"
                  name="Place"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Ort"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input custom-class="is-large" v-model="place"></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="Country"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Land"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="country"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|email"
                  name="Email"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="E-Mail-Adresse"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      type="email"
                      v-model="email"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
            </div>
          </div>

                    <div
            v-if="giftquestion !== 'selbst'"
            class="container Geschenkdaten has-text-left"
          >
            <h4 class="subtitle is-5 spacetop has-text-weight-bold">
              Deine Lieferadresse
            </h4>
            <div class="columns is-multiline">
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="buyerfirstdelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Vorname"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="buyerfirstdelivery"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="buyerlastdelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Nachname"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="buyerlastdelivery"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|min:4"
                  name="StreetNumberdelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Straße und  Nr."
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="StreetNumberdelivery"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <b-field label="weitere Adressangaben">
                  <b-input
                    custom-class="is-large"
                    v-model="adressline2delivery"
                  ></b-input>
                </b-field>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|digits:5"
                  name="zipdelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Postleitzahl"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input custom-class="is-large" v-model="zipdelivery"></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required|min:2"
                  name="Placedelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Ort"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input custom-class="is-large" v-model="placedelivery"></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">
                <ValidationProvider
                  rules="required"
                  name="Countrydelivery"
                  v-slot="{ errors, valid }"
                >
                  <b-field
                    label="Land"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                    :message="errors"
                  >
                    <b-input
                      custom-class="is-large"
                      v-model="countrydelivery"
                    ></b-input>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="coloumn column is-6">

              </div>
            </div>
          </div>

          <b-button
            type="is-info"
            size="is-large"
            class="is-pulled-left is-outlined has-text-weight-normal spacetop"
            @click="backwardstep"
            >zu Schritt 1</b-button
          >

          <b-button
            type="is-primary"
            size="is-large"
            class="is-pulled-right spacetop"
            @click="passes(forwardstep)"
            >zu Schritt 3</b-button
          >
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  required,
  confirmed,
  min,
  email,
  digits
} from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: "Dieses Feld muss ausgefüllt werden."
});

extend("email", {
  ...email,
  message: "Bitte trage eine gültige E-Mail-Adresse ein."
});

extend("min", {
  ...min,
  message: "Bitte trage mehr Zeichen ein."
});

extend("digits", {
  ...digits,
  message: "Dies ist keine gültige Postleitzahl."
});

export default {
  name: "Step2",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      giftquestion: "selbst",
      giftname: "",
      buyerfirst: "",
      buyerlast: "",
      StreetNumber: "",
      adressline2: "",
      zip: "",
      place: "",
      country: "Deutschland",
      buyerfirstdelivery: "",
      buyerlastdelivery: "",
      StreetNumberdelivery: "",
      adressline2delivery: "",
      zipdelivery: "",
      placedelivery: "",
      countrydelivery: "Deutschland",
      email: ""
    };
  },
  methods: {
    forwardstep() {
      this.$emit("activeStep", 2);
      this.$emit("giftquestions", this.giftquestion);
      this.$emit("giftnames", this.giftname);
      this.$emit("buyerfirsts", this.buyerfirst);
      this.$emit("buyerlasts", this.buyerlast);
      this.$emit("StreetNumbers", this.StreetNumber);
      this.$emit("adressline2s", this.adressline2);
      this.$emit("zips", this.zip);
      this.$emit("places", this.place);
      this.$emit("countrys", this.country);
      this.$emit("buyerfirstsdelivery", this.buyerfirstdelivery);
      this.$emit("buyerlastsdelivery", this.buyerlastdelivery);
      this.$emit("StreetNumbersdelivery", this.StreetNumberdelivery);
      this.$emit("adressline2sdelivery", this.adressline2delivery);
      this.$emit("zipsdelivery", this.zipdelivery);
      this.$emit("placesdelivery", this.placedelivery);
      this.$emit("countrysdelivery", this.countrydelivery);
      this.$emit("emails", this.email);
      this.$matomo.trackEvent(
        "Honeyprocess",
        "Step2",
        "Purchase goes to Step3:"
      );
    },
    backwardstep() {
      this.$emit("activeStep", 0);
      this.$matomo.trackEvent("Honeyprocess", "Step2", "go back to Step1");
    }
  }
};
</script>

<style lang="scss">
.b-radio.radio input[type="radio"]:checked + .check:before {
  -webkit-transform: scale(0.7) !important;
  transform: scale(0.7) !important;
}
.b-radio.radio input[type="radio"]:focus:checked + .check.is-info {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.input:focus {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
